"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.squareDependencies = void 0;
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var squareDependencies = exports.squareDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createSquare: _factoriesAny.createSquare
};